import React from 'react';
import { planConfigs } from '../../config/planConfigs';
import { Link, useIdioma } from '../../i18n';
import { useFormato } from '../../i18n/formato';
import '../../styles/Notas.css';

/**
 * O fechamento das páginas do blog: a ação principal da home. `centrada` é a
 * versão da lista, no campo índigo; no post, o título fica à esquerda e a ação
 * à direita.
 */
const Chamada = ({ titulo, centrada = false }) => {
  const { t } = useIdioma();
  const { numero } = useFormato();

  return (
    <section
      className={centrada ? 'nh-grade notas-chamada is-centrada' : 'nh-grade notas-chamada'}
      aria-labelledby="chamada-titulo"
    >
      <div className="notas-chamada-painel">
        <h2 id="chamada-titulo" data-r>{titulo}</h2>
        <div className="notas-chamada-acao" data-r style={{ '--i': 1 }}>
          <Link to="/signup" className="sp-btn sp-btn-on-section nh-btn">
            {t('notas.fimBotao')} <span className="nh-seta" aria-hidden="true">→</span>
          </Link>
          <p>{t('notas.fimNota', { paginas: numero(planConfigs.Basic.limits.pages) })}</p>
        </div>
      </div>
    </section>
  );
};

export default Chamada;
